import { render } from "./AddVikipediaModal.vue?vue&type=template&id=27cc8452&scoped=true"
import script from "./AddVikipediaModal.vue?vue&type=script&lang=js"
export * from "./AddVikipediaModal.vue?vue&type=script&lang=js"

import "./AddVikipediaModal.vue?vue&type=style&index=0&id=27cc8452&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\versatech_vex\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27cc8452"]])

export default __exports__